<template>
  <div>
    <RoomProvider></RoomProvider>
    <BookingProvider :date="date"></BookingProvider>

    <mq-layout :mq="mobiletablet" class="small-wrapper">
      <div class="sticky">
        <DateSelectGadget :date="date" @update="handleDateChange($event)"></DateSelectGadget>
        <RoomSelectGadget :roomId="roomId" @update="handleRoomChange($event)"></RoomSelectGadget>
      </div>
      <TimeTable :bookings="getBookingsByRoom(date, roomId)" :date="date" :roomId="roomId"></TimeTable>
    </mq-layout>
    <mq-layout mq="tablet+" class="wide-wrapper">
      <div class="sticky">
        <DateSelectGadget :week='true' :date="date" @update="handleDateChange($event)"></DateSelectGadget>
        <RoomSelectGadget :roomId="roomId" @update="handleRoomChange($event)"></RoomSelectGadget>
      </div>
      <TimeTableWeek :bookings="getBookingsByRoom(date, roomId)" :roomId="roomId" :date="date"
        :cols="$mq | mq({tablet: 5, laptop: 5, desktop: 7, })"
        >
      </TimeTableWeek>
    </mq-layout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import TimeTable from '@/components/TimeTable';
import TimeTableWeek from '@/components/TimeTableWeek';
import DateSelectGadget from '@/components/DateSelectGadget';
import RoomSelectGadget from '@/components/RoomSelectGadget';
import RoomProvider from '@/components/providers/RoomProvider';
import BookingProvider from '@/components/providers/BookingProvider';

import Booking from './../store/modules/booking/types';

export default {
  name: 'SingleRoomTimetableView',
  components: { RoomProvider, BookingProvider, TimeTable, TimeTableWeek, DateSelectGadget, RoomSelectGadget },
  data () {
    return {
      mobiletablet: ['mobile'],
    }
  },
  computed: {
    laptop () {
      return this.$mq === 'laptop'
    },
    roomId () {
      return this.$route.params.roomId;
    },
    date () {
      return this.$route.params.date;
    },
    ...mapGetters('Booking', [Booking.getters.GET_BOOKINGS_BY_ROOM]),
  },
  methods: {
    ...mapActions('Booking', [Booking.actions.FETCH_WEEK]),
    ...mapActions(['selectDate']),
    fetchData () {
      this.fetchWeek(this.date);
    },
    handleDateChange (newDate) {
      console.log('DATE CHANGE HANDLER');
      this.selectDate(newDate);
      this.$router.replace({
        name: 'SingleRoomTimetableView',
        params: { roomId: this.roomId, date: newDate }
      });
    },
    handleRoomChange (newRoomId) {
      console.log('ROOM CHANGE HANDLER');
      this.$router.replace({
        name: 'SingleRoomTimetableView',
        params: { roomId: newRoomId, date: this.date }
      });
    }
  }
}
</script>

<style lang="scss" scoped>

@import 'src/color.scss';

.small-wrapper {
  width: 100%;
  margin: 0 auto;
}

.wide-wrapper {
  width: 100%;
  margin: 0 auto;
}

.day-names {
  border-bottom: 1px solid $table-border-color;
}
</style>



// WEBPACK FOOTER //
// src/components/SingleRoomTimetableView.vue